<template>
    <div class="modal fade" id="send-message-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>{{transEdit('Skicka meddelande till kunder bokade')}} {{getDate(schedules[0].start)}}</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>
                <div class="modal-body pb-5">
                    <div class="row">
                        <div class="col-md-12">
                            <label>{{transEdit('Ämne')}}</label>
                            <input type="text" v-model="subject" class="form-control">
                            <label>{{transEdit('Meddelande till kunder')}}</label>
                            <textarea v-model="message" class="form-control" rows="10"></textarea>
                            <div>Detta meddelande kommer att skickas till <b>{{ numBookings }}</b> personer.</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="sendMessage" :disabled="message.length == 0 || subject.length == 0"><i class="fa fa-check"></i> {{transEdit('send')}}</button>
                    <button class="btn btn-dark" @click="closeModal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: "AdminSchedulesModalSendMessage",
    props: ['schedules'],
    data(){
        return {
            message: '',
            subject: '',
        }
    },
    computed: {
        numBookings() {
            return this.schedules.map((s) => (s.booking ? s.booking.user.email : null)).filter((s) => s !== null).length;
        },
    },

    methods: {
        sendMessage(){
            let scheduleIdArray = this.schedules.map(element => element.id);

            axios.post('/adminschedule/batch/sendmessage', {
                'schedule_id': scheduleIdArray,
                'message': this.message,
                'subject': this.subject,
            }).then((res) => {
                if(!res.error) {
                    Vue.toasted.success(res.data.data);
                    this.$emit('close');
                    let thisModal = $("#send-message-modal");
                    thisModal.modal('toggle');
                } else {
                    Vue.toasted.error(res.data[1]);
                }
            });

        },
        getDate(dateString){
            return moment(dateString).format('YYYY-MM-DD');
        },
        closeModal(){
            let thisModal = $("#send-message-modal");
            thisModal.modal('toggle');
        }
    },
    mounted(){
    }
}
</script>

<style scoped>

</style>
